import {
  Automatic, Refrigerate, ChillerIcon,
  AtivoSemMonitIcon,
  SplitPisoTetoIcon,
  SplitCasseteIcon,
  SplitHiWallIcon,
  SplitaoIcon,
  SelfIcon,
  EvaporatorIcon,
  CondenserIcon,
  FancoilIcon,
  BlockIcon,
  VentIcon,
} from '~/icons';
import { TMachine } from '.';

type DamMessage = {
  dev_id: string;
  status: string | undefined;
  Mode: string | null | undefined;
  RSSI: number | undefined;
  State: string | null;
}

type DutMessage = {
  dev_id: string;
  status: string | null | undefined;
  Temperature: number | null | undefined;
  Temperature_1: number | null | undefined;
  RSSI: number | null | undefined;
  Mode: string | null;
  State: string | null;
}

export const iconsModes = {
  Automatico: <Automatic />,
  Manual: '',
};

export const iconsStatesMachine = {
  ECO: {
    name: 'refrigerar',
    icon: <Refrigerate />,
  },
  COOL: {
    name: 'refrigerar',
    icon: <Refrigerate />,
  },
  DISABLED: {
    name: 'desligado',
    icon: <BlockIcon width={12} height={12} color="rgba(156, 156, 156, 1)" />,
  },
  FAN: {
    name: 'ventilar',
    icon: <VentIcon width={14} height={14} color="rgba(156, 156, 156, 1)" />,
  },
  ONLYFAN: {
    name: 'ventilar',
    icon: <VentIcon width={14} height={14} color="rgba(156, 156, 156, 1)" />,
  },
};

export function returnTempAlert(temp, tmin, tmax) {
  if ((tmin != null) && (temp < tmin)) {
    return 'low';
  }
  if ((tmax != null) && (temp > tmax)) {
    return 'high';
  }
  return 'good';
}

export const iconsMachineTypes = {
  chiller: <ChillerIcon width={24} height={24} color="rgba(15, 15, 54, 1)" />,
  'tipo-fancoil': <FancoilIcon width={24} height={24} color="rgba(15, 15, 54, 1)" />,
  condensadora: <CondenserIcon width={24} height={24} color="rgba(15, 15, 54, 1)" />,
  evaporadora: <EvaporatorIcon width={24} height={24} color="rgba(15, 15, 54, 1)" />,
  self: <SelfIcon width={24} height={24} color="rgba(15, 15, 54, 1)" />,
  splitao: <SplitaoIcon width={24} height={24} color="rgba(15, 15, 54, 1)" />,
  'split-hi-wall': <SplitHiWallIcon width={24} height={24} color="rgba(15, 15, 54, 1)" />,
  'split-cassete': <SplitCasseteIcon width={24} height={24} color="rgba(15, 15, 54, 1)" />,
  'split-piso-teto': <SplitPisoTetoIcon width={24} height={24} color="rgba(15, 15, 54, 1)" />,
  semMonit: <AtivoSemMonitIcon width={24} height={24} color="rgba(15, 15, 54, 1)" />,
};

export function updateDamStatus(message: DamMessage, devsList: TMachine[], statusOnly: boolean): boolean {
  const dev = devsList.find((row) => row.DEV_AUT_CODE === message.dev_id);
  const environment = dev?.ENVIRONMENTS[0];
  const isSelfReference = environment?.SELF_REFERENCE;
  if (dev) {
    dev.status = message.status;
    if (!statusOnly) {
      dev.Mode = message.Mode;
      dev.RSSI = message.RSSI;

      if (isSelfReference) {
        const newTemperature = message[environment.RETURN_TEMPERATURE_FIELD ?? 'Temperature'];
        environment.Temperature = newTemperature ?? environment.Temperature;
      }

      if (dev.useTelemetry || message.State === dev.OPERATION) {
        dev.useTelemetry = true;
        dev.OPERATION = message.State;
      }
    }
    if (dev.status !== 'ONLINE') {
      dev.Mode = null;
      dev.OPERATION = null;
    }
    return true;
  }
  return false;
}

export function updateDutStatus(message: DutMessage, machineList: TMachine[], type: 'dutAutTelemetry' | 'dutStatus'): boolean {
  let found = false;
  for (const machine of machineList) {
    let dev;
    if (type === 'dutAutTelemetry' && machine.DEV_AUT_CODE === message.dev_id) {
      dev = machine;
    } else {
      dev = machine.ENVIRONMENTS.find((env) => env.DUT_CODE === message.dev_id);
    }
    if (dev) {
      const status = message.status ? message.status : dev.status;
      if (status !== 'ONLINE') return found;
      dev.status = status;
      dev.Temperature = message.Temperature ? message.Temperature : dev.Temperature;
      dev.Temperature_1 = message.Temperature_1;
      dev.RSSI = message.RSSI ?? dev.RSSI;
      dev.Mode = message.Mode ?? dev.Mode;
      found = true;

      const nextState = message.State ?? dev.State;
      if (dev.useTelemetry || message.State === dev.OPERATION) {
        dev.useTelemetry = true;
        dev.OPERATION = nextState;
      }
    }
  }
  return found;
}
